import React from 'react';
import ReactDOM from 'react-dom/client';
import Login from './Login';
//import Temp from './Temp';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Login />
  </React.StrictMode>
);


